<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.game_result_details")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-5.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.product')" size="sm")
                  b-form-select(
                    ref="product"
                    v-model="product"
                    :options="getPlatformLookUp()"
                    size="sm"
                    :disabled="loading"
                    @change="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :dirty="$v.member_id.$dirty"
                    :error="$v.member_id.$error"
                    :placeholder='$t("ui.member_id")'
                    v-model.trim.lazy="$v.member_id.$model"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.sport_type')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="sport_type"
                    :placeholder='$t("ui.sport_type")'
                    v-model="sport_type"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.league_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="league_id"
                    :placeholder='$t("ui.league_id")'
                    v-model="league_id"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.match_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="match_id"
                    :placeholder='$t("ui.match_id")'
                    v-model="match_id"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="!['SPORTSBOOK','LOTTERY','TOURNAMENT','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.game_name')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="game_name"
                    :placeholder='$t("ui.game_name")'
                    v-model="game_name"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="!['SPORTSBOOK','LOTTERY','TOURNAMENT','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.game_provider')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="game_provider"
                    :placeholder='$t("ui.game_provider")'
                    v-model="game_provider"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-form-checkbox(
                  ref="working_date"
                  v-model="working_date"
                ) {{ this.$t("message.search_with_working_date") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton.mr-2(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                .ml-auto
                  jsonToExcel(v-if="gameResultList.length > 0" mode="GameResult" :date="dateRange" :jsonDetails="gameResultList")
            b-row.mb-2(v-if="lines")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-3.p-l-10
                  b-breadcrumb-item(
                    v-for="(item,index) in lines"
                    :key="index"
                    :text="item.account_id.toUpperCase()"
                    :class="{ active: index==lines.length-1 }"
                    :title="$helpers.getUplineName(item.account_type)"
                    @click="redirectTo(item.account_id, 'dailyWinlose')"
                  )
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" responsive :no-local-sorting="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="gameResultList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:thead-top="row")
                    tr
                      th.bg-grey-lighter(:colspan="!['LOTTERY'].includes(product) ? 6 : 5")
                      template(v-for="level in downlineLevel")
                        th.text-center(colspan="3" :class="'bg-grey-transparent-'+level") {{ $helpers.getUplineName(level) }}
                      th.text-center.bg-grey-transparent-7(colspan="3") {{ $t("ui.company") }}
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(bet_time)="row")
                    template(v-if="product == 'COCKFIGHT'")
                      span {{ $moment(row.item.settlement_datetime).format("YYYY-MM-DD HH:mm:ss") }}
                      br
                      span #[b {{ row.item.bet_id }}]
                      br
                      span {{ row.item.client_ip }}
                    template(v-if="product == 'TOURNAMENT'")
                      span {{ $moment(row.item.bet_on).format("YYYY-MM-DD HH:mm:ss") }}
                      br
                      span #[b {{ row.item.bet_id }}]
                    template(v-else)
                      span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                      br
                      span #[b {{ row.item.ori_result_id ? row.item.ori_result_id + ' (' + $t("ui.void").toUpperCase() + ')' : row.item.result_id }}]
                      br
                      span {{ row.item.ip }}
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    template(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                      template(v-if="row.item.bet_type == 'PARLAY'")
                        span(v-if="row.item.bet_type_share == 'PARLAYMMO'") #[b {{ $t("ui.mmo_parlay") }}]
                        span(v-else) #[b {{ $t("ui.mix_parlay") }}]
                        div
                          span.mr-1 {{ $helpers.displayBetDetail(row.item) }} @
                          span {{ row.item.odds_display_bet }}
                      template(v-else)
                        div
                          span.badge.bg-blue-darker.mr-1 {{ row.item.league_id }}
                          span {{ getName(row.item.league_id, 0) }}
                        div(v-if="row.item.home_team_name != null")
                          span.badge.bg-orange-darker.mr-1 {{ row.item.match_id }}
                          span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                          span.mr-1 vs
                          span(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                        div(v-if="row.item.match_time")
                          span.mr-1 {{ $moment(row.item.match_time).format("YYYY-MM-DD HH:mm:ss") }}
                          span(v-if="isLiveMarket(row.item)") ({{ row.item.home_running_score}} - {{ row.item.away_running_score }})
                    template(v-else-if="product == 'LOTTERY'")
                      span #[b {{ $t("m.D_"  + row.item.bet_type) }}]
                      div {{ row.item.comp_name }} - {{ row.item.num_type }}
                      div {{ $moment(row.item.match_date).format("YYYY-MM-DD") }}
                    template(v-else-if="product == 'COCKFIGHT'")
                      span.badge.bg-blue-darker {{ row.item.event_id }}
                      br
                      template(v-if="!row.item.is_combo")
                        span.mr-1 #[b {{ row.item.game_type_name }}] ({{ row.item.game_market_name }})
                        br
                        span {{ row.item.competition_name }}
                        br
                        span {{ row.item.event_name }}
                        br
                      span {{ $moment(row.item.event_datetime).format("YYYY-MM-DD HH:mm:ss") }}
                    template(v-else-if="product == 'TOURNAMENT'")
                      template(v-if="row.item.room_type")
                        span {{ $t("ui.room_" + row.item.room_type) }}
                        br
                      span.mr-1 No.{{ row.item.room_id }}
                      template(v-if="row.item.position")
                        i.fas.fa-trophy.gold-trophy(v-if="row.item.position == 1")
                        i.fas.fa-trophy.silver-trophy(v-if="row.item.position == 2")
                        i.fas.fa-trophy.bronze-trophy(v-if="row.item.position == 3")
                    template(v-else)
                      div
                        span {{ row.item.game_provider }} @ {{ row.item.bet_id }}
                      div
                        span {{ row.item.game_name }}
                  template(v-slot:cell(detail)="row")
                    template(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                      template(v-if="row.item.bet_type == 'PARLAY'")
                        span @ {{ row.item.odds_display }}
                        div
                          span.label.bg-black {{ $t("ui.details") }}
                          template(v-if="row.item.bet_type_share == 'PARLAYMMO'")
                            i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetailMMO(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                          template(v-else)
                            i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      template(v-else)
                        div.mb-1
                          span.label.bg-black #[b {{ getBetType(row.item) }}]
                        div
                          span.mr-1(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item, getName(row.item.match_id, 1), getName(row.item.match_id, 2)) }}
                        div
                          span {{ $helpers.displayBetDetail(row.item) }}
                          br
                          span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                          span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                          br
                          span.mr-1(v-if="row.item.bet_type") {{ row.item.bet_type.charAt(row.item.bet_type.length-1) == 'H' ? 'FH' : 'FT' }}
                          span {{ row.item.home_score }} - {{ row.item.away_score }}
                          template(v-if="row.item.cash_out")
                            br
                            span(style="color: red;") {{ $t("ui.cashout") }}
                          template(v-if="row.item.criteria1 && ['HDP', 'HDPH', 'OU', 'OUH'].includes(row.item.bet_type)")
                            br
                            span {{ $t("ui.time_machine") }}: {{ tmDisplay(row.item.criteria1) }}
                    template(v-else-if="product == 'COCKFIGHT'")
                      div.mb-1
                        template(v-if="!row.item.is_combo")
                          span.label.bg-black {{ row.item.bet_type_name }}
                          br
                          span.text-capitalize {{ row.item.bet_selection }} @ {{ row.item.member_odds }}
                        template(v-else)
                          span.label.bg-info COMBO
                          br
                          span @ {{ row.item.member_odds }}
                          br
                          span.label.bg-black {{ $t("ui.details") }}
                          i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getEsports2Combo(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                    template(v-else-if="product == 'LOTTERY'")
                      .small
                        span.mr-1 {{ $t("ui.turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.payout") }} @
                        span(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                      .small.badge.badge-dark #[b {{ '\u200C' + row.item.number.toString() }}]
                      .small(v-if="parseFloat(row.item.big) > 0")
                        span {{ row.item.num_type == "4D" ? $t("m.D_BIG") : "AE" }}
                        span  x {{ row.item.big | currency }}
                      .small(v-if="parseFloat(row.item.small) > 0")
                        span {{ $t("m.D_SMALL") }}
                        span  x {{ row.item.small | currency }}
                      .small(v-if="parseFloat(row.item.sa) > 0")
                        span {{ row.item.num_type == "4D" ? "SA" : "A" }}
                        span  x {{ row.item.sa | currency }}
                      .small(v-if="parseFloat(row.item.sb) > 0")
                        span B
                        span  x {{ row.item.sb | currency }}
                      .small(v-if="parseFloat(row.item.sc) > 0")
                        span C
                        span  x {{ row.item.sc | currency }}
                      .small(v-if="parseFloat(row.item.sd) > 0")
                        span D
                        span  x {{ row.item.sd | currency }}
                      .small(v-if="parseFloat(row.item.se) > 0")
                        span E
                        span  x {{ row.item.se | currency }}
                      .small(v-if="parseFloat(row.item.aa) > 0")
                        span AA
                        span  x {{ row.item.aa | currency }}
                      .small(v-if="parseFloat(row.item.abc) > 0")
                        span ABC
                        span  x {{ row.item.abc | currency }}
                    template(v-else-if="product == 'TOURNAMENT'")
                      .small
                        span.mr-1 {{ $t("ui.turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.valid_turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.payout") }} @
                        span(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                    template(v-else)
                      .small
                        span.mr-1 {{ $t("ui.turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.valid_turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.payout") }} @
                        span(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                      .small(v-if="!['DBP'].includes(row.item.game_provider)")
                        template(v-if="['AR', 'PGS', 'PP', 'JK', 'SP', 'JILI', 'PP-C', 'UU', 'NEXT', 'DB', 'WOW', 'AI', 'WF', 'OSG', 'EPW', 'SEXYBCRT', 'BI', 'ONLIVE', 'MTLIVE'].includes(row.item.game_provider)")
                          template(v-if="row.item.game_provider == 'AR'")
                            a(v-if="!detail.arcadia" href="javascript:void(0);" title='Result' @click="getResultAR(row.item.bet_id)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'PGS'")
                            a(v-if="!detail.pgsoft" href="javascript:void(0);" title='Result' @click="getResultPGS(row.item.bet_id)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'PP'")
                            a(v-if="!detail.pragmatic" href="javascript:void(0);" title='Result' @click="getResultPPG(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'JK'")
                            a(v-if="!detail.joker" href="javascript:void(0);" title='Result' @click="getResultJKR(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'SP'")
                            a(v-if="!detail.spp" href="javascript:void(0);" title='Result' @click="getResultSPP(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'JILI'")
                            a(v-if="!detail.jili" href="javascript:void(0);" title='Result' @click="getResultJILI(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'PP-C'")
                            a(v-if="!detail.lcppg" href="javascript:void(0);" title='Result' @click="getResultLCPPG(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'UU'")
                            a(v-if="!detail.uusl" href="javascript:void(0);" title='Result' @click="getResultUUSL(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'NEXT'")
                            a(v-if="!detail.next" href="javascript:void(0);" title='Result' @click="getResultNEXT(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'DB'")
                            a(v-if="!detail.dbhash" href="javascript:void(0);" title='Result' @click="getResultDbHash(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'WOW'")
                            a(v-if="!detail.wow" href="javascript:void(0);" title='Result' @click="getResultWOW(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'AI'")
                            a(v-if="!detail.ai" href="javascript:void(0);" title='Result' @click="getResultAI(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'WF'")
                            a(v-if="!detail.wf" href="javascript:void(0);" title='Result' @click="getResultWF(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'EPW'")
                            a(v-if="!detail.epw" href="javascript:void(0);" title='Result' @click="getResultEPW(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'OSG'")
                            a(v-if="!detail.live22" href="javascript:void(0);" title='Result' @click="getResultLive22Gaming(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'SEXYBCRT'")
                            a(v-if="!detail.awc" href="javascript:void(0);" title='Result' @click="getResultAWC(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'BI'")
                            a(v-if="!detail.aio" href="javascript:void(0);" title='Result' @click="getResultAIO(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'ONLIVE'")
                            a(v-if="!detail.onlive" href="javascript:void(0);" title='Result' @click="getResultOnlive(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                          template(v-if="row.item.game_provider == 'MTLIVE'")
                            a(v-if="!detail.mtlive" href="javascript:void(0);" title='Result' @click="getResultMtlive(row.item)")
                              i.fas.fa-poll
                            a(v-else href="javascript:void(0);")
                              i.fa.fa-spin.fa-spinner
                        template(v-else)
                          //- a(v-if="!detail.live22" href="javascript:void(0);" title='Result' @click="getResultLive22Gaming(row.item)")
                          //-   i.fas.fa-poll
                          //- a(v-else href="javascript:void(0);")
                          //-   i.fa.fa-spin.fa-spinner
                          a(:href="resultUrl(row.item)" :title='$t("ui.game_result")' target="result" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
                            i.fas.fa-poll
                  template(v-slot:row-details="row")
                    template(v-if="product == 'COCKFIGHT'")
                      b-table#innerTable.table-sm(show-empty :items="esports2Combo" :fields="es2fields")
                        template(v-slot:cell(index)="row")
                          span {{ row.index + 1 }}
                        template(v-slot:cell(event_datetime)="row")
                          span {{ $moment(row.item.event_datetime).format("YYYY-MM-DD") }}
                        template(v-slot:cell(home_team_name)="row")
                          span(v-if="row.item.event_name") {{ row.item.event_name.split("vs")[0].toString() }}
                        template(v-slot:cell(away_team_name)="row")
                          span(v-if="row.item.event_name") {{ row.item.event_name.split("vs")[1].toString() }}
                        template(v-slot:cell(bet)="row")
                          span(v-if="row.item.bet_selection") {{ row.item.bet_selection == 'home' ? row.item.event_name.split("vs")[0].toString() : row.item.event_name.split("vs")[1].toString() }}
                    template(v-else)
                      b-table#innerTable.table-sm(show-empty :items="parlayList" :fields="vDfields")
                        template(v-slot:cell(index)="row")
                          span {{ row.index + 1 }}
                        template(v-slot:cell(working_date)="row")
                          span {{ $moment(row.item.working_date).format("YYYY-MM-DD HH:mm:ss") }}
                        template(v-slot:cell(league_name)="row")
                          span {{ getParlayName(row.item.league_id, 0) }}
                        template(v-slot:cell(home_team_name)="row")
                          span(:class="row.item.home_giving == 1 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 1) }}
                        template(v-slot:cell(away_team_name)="row")
                          span(:class="row.item.home_giving == 0 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 2) }}
                        template(v-slot:cell(full_half)="row")
                          span {{ (row.item.full_half == 1) ? $t("ui.full_time") : $t("ui.half_time") }}
                        template(v-slot:cell(running_score)="row")
                          span {{ row.item.running_score ? row.item.running_score : '-' }}
                        template(v-slot:cell(status)="row")
                          template(v-if="isMMO")
                            span {{ $helpers.showWinStatusMMO(row.item) }}
                          template(v-else)
                            span {{ $helpers.showWinStatus(row.item) }}
                  template(v-slot:cell(pt_share)="row" v-if="!['LOTTERY','TOURNAMENT'].includes(product)")
                    div(v-if="downlineLevel == 6")
                      span.small {{ $helpers.getUplineName(6) + " " + row.item["shareholder_pt"] + "%" }}
                    div(v-if="downlineLevel >= 5")
                      span.small {{ $helpers.getUplineName(5) + " " + row.item["s_senior_pt"] + "%" }}
                    div(v-if="downlineLevel >= 4")
                      span.small {{ $helpers.getUplineName(4) + " " + row.item["senior_pt"] + "%" }}
                    div(v-if="downlineLevel >= 3")
                      span.small {{ $helpers.getUplineName(3) + " " + row.item["master_pt"] + "%" }}
                    div.pt-col(v-if="downlineLevel >= 2")
                      span.small {{ $helpers.getUplineName(2) + " " + row.item["agent_pt"] + "%" }}
                  template(v-slot:cell(jackpot_payout)="row" v-if="['TOURNAMENT'].includes(product)")
                    span(:class="$helpers.getNumberClass(row.item.jackpot_payout)") #[b {{ row.item.jackpot_payout | currency }} ]
                  template(v-slot:cell(winlose)="row" v-if="product == 'LOTTERY'")
                    span(:class="$helpers.getNumberClass(row.item.winlose)") #[b {{ row.item.winlose | currency }} ]
                  template(v-slot:cell(member_winlose)="row" v-if="product != 'LOTTERY'")
                    span(:class="$helpers.getNumberClass(row.item.member_winlose)") #[b {{ row.item.member_winlose | currency }} ]
                  template(v-slot:cell(member_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.member_comm)") #[b {{ row.item.member_comm | currency }} ]
                  template(v-slot:cell(member_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.member_winlose_comm)") #[b {{ row.item.member_winlose_comm | currency }} ]
                  template(v-slot:cell(agent_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.agent_winlose)") #[b {{ row.item.agent_winlose | currency }} ]
                  template(v-slot:cell(agent_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.agent_comm)") #[b {{ row.item.agent_comm | currency }} ]
                  template(v-slot:cell(agent_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.agent_winlose_comm)") #[b {{ row.item.agent_winlose_comm | currency }} ]
                  template(v-slot:cell(master_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.master_winlose)") #[b {{ row.item.master_winlose | currency }} ]
                  template(v-slot:cell(master_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.master_comm)") #[b {{ row.item.master_comm | currency }} ]
                  template(v-slot:cell(master_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.master_winlose_comm)") #[b {{ row.item.master_winlose_comm | currency }} ]
                  template(v-slot:cell(senior_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.senior_winlose)") #[b {{ row.item.senior_winlose | currency }} ]
                  template(v-slot:cell(senior_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.senior_comm)") #[b {{ row.item.senior_comm | currency }} ]
                  template(v-slot:cell(senior_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.senior_winlose_comm)") #[b {{ row.item.senior_winlose_comm | currency }} ]
                  template(v-slot:cell(s_senior_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.s_senior_winlose)") #[b {{ row.item.s_senior_winlose | currency }} ]
                  template(v-slot:cell(s_senior_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.s_senior_comm)") #[b {{ row.item.s_senior_comm | currency }} ]
                  template(v-slot:cell(s_senior_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.s_senior_winlose_comm)") #[b {{ row.item.s_senior_winlose_comm | currency }} ]
                  template(v-slot:cell(shareholder_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.shareholder_winlose)") #[b {{ row.item.shareholder_winlose | currency }} ]
                  template(v-slot:cell(shareholder_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.shareholder_comm)") #[b {{ row.item.shareholder_comm | currency }} ]
                  template(v-slot:cell(shareholder_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.shareholder_winlose_comm)") #[b {{ row.item.shareholder_winlose_comm | currency }} ]
                  template(v-slot:cell(company_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.company_winlose)") #[b {{ row.item.company_winlose | currency }} ]
                  template(v-slot:cell(company_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.company_comm)") #[b {{ row.item.company_comm | currency }} ]
                  template(v-slot:cell(company_winlose_comm)="row")
                    span(:class="$helpers.getNumberClass(row.item.company_winlose_comm)") #[b {{ row.item.company_winlose_comm | currency }} ]
                  template(v-slot:bottom-row="row" v-if="showTotal")
                    td.text-right(:colspan="!['LOTTERY'].includes(product) ? 6 : 5")
                      span #[b {{ $t("ui.sub_total") }}]
                      br
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right(v-if="['TOURNAMENT'].includes(product)")
                      span(:class="$helpers.getNumberClass(subTotalJackpot)")  #[b {{ subTotalJackpot | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalJackpot)")  #[b {{ grandTotalJackpot | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalMemberWinlose)")  #[b {{ subTotalMemberWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMemberWinlose)")  #[b {{ grandTotalMemberWinlose | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalMemberCommission)")  #[b {{ subTotalMemberCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMemberCommission)")  #[b {{ grandTotalMemberCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalMemberWinloseCommission)")  #[b {{ subTotalMemberWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMemberWinloseCommission)")  #[b {{ grandTotalMemberWinloseCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalAgentWinlose)")  #[b {{ subTotalAgentWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalAgentWinlose)")  #[b {{ grandTotalAgentWinlose | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalAgentCommission)")  #[b {{ subTotalAgentCommission | currency }}]
                      br.
                      span(:class="$helpers.getNumberClass(grandTotalAgentCommission)")  #[b {{ grandTotalAgentCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalAgentWinloseCommission)")  #[b {{ subTotalAgentWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalAgentWinloseCommission)")  #[b {{ grandTotalAgentWinloseCommission | currency }} ]
                    td.text-right(v-if="isShow(3)")
                      span(:class="$helpers.getNumberClass(subTotalMasterWinlose)")  #[b {{ subTotalMasterWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMasterWinlose)")  #[b {{ grandTotalMasterWinlose | currency }} ]
                    td.text-right(v-if="isShow(3)")
                      span(:class="$helpers.getNumberClass(subTotalMasterCommission)")  #[b {{ subTotalMasterCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMasterCommission)")  #[b {{ grandTotalMasterCommission | currency }} ]
                    td.text-right(v-if="isShow(3)")
                      span(:class="$helpers.getNumberClass(subTotalMasterWinloseCommission)")  #[b {{ subTotalMasterWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMasterWinloseCommission)")  #[b {{ grandTotalMasterWinloseCommission | currency }} ]
                    td.text-right(v-if="isShow(4)")
                      span(:class="$helpers.getNumberClass(subTotalSeniorWinlose)")  #[b {{ subTotalSeniorWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSeniorWinlose)")  #[b {{ grandTotalSeniorWinlose | currency }} ]
                    td.text-right(v-if="isShow(4)")
                      span(:class="$helpers.getNumberClass(subTotalSeniorCommission)")  #[b {{ subTotalSeniorCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSeniorCommission)")  #[b {{ grandTotalSeniorCommission | currency }} ]
                    td.text-right(v-if="isShow(4)")
                      span(:class="$helpers.getNumberClass(subTotalSeniorWinloseCommission)")  #[b {{ subTotalSeniorWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSeniorWinloseCommission)")  #[b {{ grandTotalSeniorWinloseCommission | currency }} ]
                    td.text-right(v-if="isShow(5)")
                      span(:class="$helpers.getNumberClass(subTotalSuperSeniorWinlose)")  #[b {{ subTotalSuperSeniorWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSuperSeniorWinlose)")  #[b {{ grandTotalSuperSeniorWinlose | currency }} ]
                    td.text-right(v-if="isShow(5)")
                      span(:class="$helpers.getNumberClass(subTotalSuperSeniorCommission)")  #[b {{ subTotalSuperSeniorCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSuperSeniorCommission)")  #[b {{ grandTotalSuperSeniorCommission | currency }} ]
                    td.text-right(v-if="isShow(5)")
                      span(:class="$helpers.getNumberClass(subTotalSuperSeniorWinloseCommission)")  #[b {{ subTotalSuperSeniorWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSuperSeniorWinloseCommission)")  #[b {{ grandTotalSuperSeniorWinloseCommission | currency }} ]
                    td.text-right(v-if="isShow(6)")
                      span(:class="$helpers.getNumberClass(subTotalShareholderWinlose)")  #[b {{ subTotalShareholderWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalShareholderWinlose)")  #[b {{ grandTotalShareholderWinlose | currency }} ]
                    td.text-right(v-if="isShow(6)")
                      span(:class="$helpers.getNumberClass(subTotalShareholderCommission)")  #[b {{ subTotalShareholderCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalShareholderCommission)")  #[b {{ grandTotalShareholderCommission | currency }} ]
                    td.text-right(v-if="isShow(6)")
                      span(:class="$helpers.getNumberClass(subTotalShareholderWinloseCommission)")  #[b {{ subTotalShareholderWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalShareholderWinloseCommission)")  #[b {{ grandTotalShareholderWinloseCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalCompanyWinlose)")  #[b {{ subTotalCompanyWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalCompanyWinlose)")  #[b {{ grandTotalCompanyWinlose | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalCompanyCommission)")  #[b {{ subTotalCompanyCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalCompanyCommission)")  #[b {{ grandTotalCompanyCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalCompanyWinloseCommission)")  #[b {{ subTotalCompanyWinloseCommission | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalCompanyWinloseCommission)")  #[b {{ grandTotalCompanyWinloseCommission | currency }} ]
</template>

<script>
import config from "@/config";
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton.vue";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DatePicker,
    jsonToExcel
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      lines: this.$store.getters.getTier,
      downlineLevel: this.$store.getters.accountType,
      product: this.$store.getters.getPlatform,
      member_id: [11, 12].includes(this.$store.getters.getSelectedID.length) ? this.$store.getters.getSelectedID : "",
      sport_type: this.$store.getters.getSportType,
      league_id: this.$store.getters.getLeagueID.id,
      match_id: this.$store.getters.getMatchID.id,
      game_name: "",
      game_provider: "",
      working_date: true,
      gameResultList: [],
      parlayList: [],
      esports2Combo: [],
      isMMO: false,
      subTotalJackpot: 0,
      grandTotalJackpot: 0,
      subTotalGrossWinlose: 0,
      grandTotalGrossWinlose: 0,
      subTotalGrossCommission: 0,
      grandTotalGrossCommission: 0,
      // member
      subTotalMemberWinlose: 0,
      grandTotalMemberWinlose: 0,
      subTotalMemberCommission: 0,
      grandTotalMemberCommission: 0,
      subTotalMemberWinloseCommission: 0,
      grandTotalMemberWinloseCommission: 0,
      // agent / current login level
      subTotalAgentWinlose: 0,
      grandTotalAgentWinlose: 0,
      subTotalAgentCommission: 0,
      grandTotalAgentCommission: 0,
      subTotalAgentWinloseCommission: 0,
      grandTotalAgentWinloseCommission: 0,
      // master
      subTotalMasterWinlose: 0,
      grandTotalMasterWinlose: 0,
      subTotalMasterCommission: 0,
      grandTotalMasterCommission: 0,
      subTotalMasterWinloseCommission: 0,
      grandTotalMasterWinloseCommission: 0,
      // senior
      subTotalSeniorWinlose: 0,
      grandTotalSeniorWinlose: 0,
      subTotalSeniorCommission: 0,
      grandTotalSeniorCommission: 0,
      subTotalSeniorWinloseCommission: 0,
      grandTotalSeniorWinloseCommission: 0,
      // super senior
      subTotalSuperSeniorWinlose: 0,
      grandTotalSuperSeniorWinlose: 0,
      subTotalSuperSeniorCommission: 0,
      grandTotalSuperSeniorCommission: 0,
      subTotalSuperSeniorWinloseCommission: 0,
      grandTotalSuperSeniorWinloseCommission: 0,
      // shareholder
      subTotalShareholderWinlose: 0,
      grandTotalShareholderWinlose: 0,
      subTotalShareholderCommission: 0,
      grandTotalShareholderCommission: 0,
      subTotalShareholderWinloseCommission: 0,
      grandTotalShareholderWinloseCommission: 0,
      // company
      subTotalCompanyWinlose: 0,
      grandTotalCompanyWinlose: 0,
      subTotalCompanyCommission: 0,
      grandTotalCompanyCommission: 0,
      subTotalCompanyWinloseCommission: 0,
      grandTotalCompanyWinloseCommission: 0,
      showTotal: false,
      filter: null,
      sortBy: "bet_time",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      match: [],
      league: [],
      matchParlay: [],
      leagueParlay: [],
      detail: {
        arcadia: false,
        pgsoft: false,
        pragmatic: false,
        joker: false,
        spp: false,
        jili: false,
        lcppg: false,
        uusl: false,
        next: false,
        dbhash: false,
        wow: false,
        ai: false,
        live22: false,
        wf: false,
        epw: false,
        awc: false,
        aio: false,
        onlive: false,
        mtlive: false
      }
    };
  },
  validations: {
    member_id: {
      required
    }
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format(
          "YYYY-MM-DD"
        )
      };
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "bet_time",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        !['LOTTERY','TOURNAMENT'].includes(this.product) ? {
          key: "pt_share",
          label: this.$t("ui.pt_share"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        } : {},
        ['TOURNAMENT'].includes(this.product) ? {
          key: "jackpot_payout",
          label: this.$t("ui.jackpot"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.product == 'LOTTERY' ? {
          key: "winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        } : {
          key: "member_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "agent_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-2",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "agent_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-2",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "agent_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-2",
          thStyle: {
            width: "10px"
          }
        },
        this.isShow(3) ? {
          key: "master_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-3",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(3) ? {
          key: "master_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-3",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(3) ? {
          key: "master_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-3",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(4) ? {
          key: "senior_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-4",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(4) ? {
          key: "senior_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-4",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(4) ? {
          key: "senior_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-4",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(5) ? {
          key: "s_senior_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-5",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(5) ? {
          key: "s_senior_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-5",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(5) ? {
          key: "s_senior_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-5",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(6) ? {
          key: "shareholder_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-6",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(6) ? {
          key: "shareholder_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-6",
          thStyle: {
            width: "7%"
          }
        } : {},
        this.isShow(6) ? {
          key: "shareholder_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-6",
          thStyle: {
            width: "7%"
          }
        } : {},
        {
          key: "company_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-7",
          thStyle: {
            width: "10px"
          }
        },
        {
          key: "company_comm",
          label: this.$t("ui.winlose_column2"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-7",
          thStyle: {
            width: "10px"
          }
        },
        {
          key: "company_winlose_comm",
          label: this.$t("ui.total"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-7",
          thStyle: {
            width: "10px"
          }
        }
      ];
    },
    vDfields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "working_date",
          label: this.$t("ui.date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_half",
          label: this.$t("ui.match_time"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "payout_odds",
          label: this.$t("ui.payout"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_score",
          label: this.$t("ui.home_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_score",
          label: this.$t("ui.away_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "running_score",
          label: this.$t("ui.running_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ];
    },
    es2fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-dark-lighter text-white"
        },
        {
          key: "event_datetime",
          label: this.$t("ui.date"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "competition_name",
          label: this.$t("ui.league_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "bet_type_name",
          label: this.$t("ui.bet_type"),
          thClass: "bg-dark-lighter text-white",
          class: "text-center"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          thClass: "bg-dark-lighter text-white",
        },
        {
          key: "member_odds",
          label: this.$t("ui.odds_display"),
          thClass: "bg-dark-lighter text-white",
          class: "text-center"
        },
        {
          key: "result",
          label: this.$t("ui.result"),
          thClass: "bg-dark-lighter text-white",
          class: "text-center"
        },
        {
          key: "result_status",
          label: this.$t("ui.status"),
          thClass: "bg-dark-lighter text-white",
          class: "align-middle text-center"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize;
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC";
    },
    subTotal() {
      var result = [];

      if (this.downlineLevel >= 2)
        result = result.concat([
          this.subTotalAgentWinlose.toFixed(2),
          this.subTotalAgentCommission.toFixed(2),
          this.subTotalAgentWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 3)
        result = result.concat([
          this.subTotalMasterWinlose.toFixed(2),
          this.subTotalMasterCommission.toFixed(2),
          this.subTotalMasterWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 4)
        result = result.concat([
          this.subTotalSeniorWinlose.toFixed(2),
          this.subTotalSeniorCommission.toFixed(2),
          this.subTotalSeniorWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 5)
        result = result.concat([
          this.subTotalSuperSeniorWinlose.toFixed(2),
          this.subTotalSuperSeniorCommission.toFixed(2),
          this.subTotalSuperSeniorWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel == 6)
        result = result.concat([
          this.subTotalShareholderWinlose.toFixed(2),
          this.subTotalShareholderCommission.toFixed(2),
          this.subTotalShareholderWinloseCommission.toFixed(2)
        ]);

      return new Array(
        [
          this.subTotalMemberWinlose.toFixed(2),
          this.subTotalMemberCommission.toFixed(2),
          this.subTotalMemberWinloseCommission.toFixed(2)
        ],
        result,
        [
          this.subTotalCompanyWinlose.toFixed(2),
          this.subTotalCompanyCommission.toFixed(2),
          this.subTotalCompanyWinloseCommission.toFixed(2)
        ]
      );
    },
    grandTotal() {
      var result = [];

      if (this.downlineLevel >= 2)
        result = result.concat([
          this.grandTotalAgentWinlose.toFixed(2),
          this.grandTotalAgentCommission.toFixed(2),
          this.grandTotalAgentWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 3)
        result = result.concat([
          this.grandTotalMasterWinlose.toFixed(2),
          this.grandTotalMasterCommission.toFixed(2),
          this.grandTotalMasterWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 4)
        result = result.concat([
          this.grandTotalSeniorWinlose.toFixed(2),
          this.grandTotalSeniorCommission.toFixed(2),
          this.grandTotalSeniorWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel >= 5)
        result = result.concat([
          this.grandTotalSuperSeniorWinlose.toFixed(2),
          this.grandTotalSuperSeniorCommission.toFixed(2),
          this.grandTotalSuperSeniorWinloseCommission.toFixed(2)
        ]);
      if (this.downlineLevel == 6)
        result = result.concat([
          this.grandTotalShareholderWinlose.toFixed(2),
          this.grandTotalShareholderCommission.toFixed(2),
          this.grandTotalShareholderWinloseCommission.toFixed(2)
        ]);

      return new Array(
        [
          this.grandTotalMemberWinlose.toFixed(2),
          this.grandTotalMemberCommission.toFixed(2),
          this.grandTotalMemberWinloseCommission.toFixed(2)
        ],
        result,
        [
          this.grandTotalCompanyWinlose.toFixed(2),
          this.grandTotalCompanyCommission.toFixed(2),
          this.grandTotalCompanyWinloseCommission.toFixed(2)
        ]
      );
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    this.$store.dispatch("user/getPlatformLookUp")
    if (this.member_id != "") {
      this.submit();
    }
  },
  methods: {
    tmDisplay(tm_time) {
      if (tm_time == null || tm_time === "") {
        return "";
      }
      const startLabel = "00:00";
      const endLabel = String(tm_time).padStart(2, "0") + ":00";
      return "(" + [startLabel, endLabel].join(" - ") + ")";
    },
    isLiveMarket: function(item) {
      return item.market_type == 3 && (item.bet_type == 'HDP' || item.bet_type == 'HDPH' || item.bet_type == 'OU' || item.bet_type =='OUH')
    },
    getBetType(item) {
      let type = item.bet_type
      let share = item.bet_type_share

      if(type == 'HDP' && share == 'HDPMMO') {
        return this.$tc("m.BT_HDPMMO")
      }

      if(type == 'OU' && share == 'HDPMMO') {
        return this.$tc("m.BT_OUMMO")
      }

      return this.$tc("m.BT_" + type, 2)
    },
    redirectTo: function(id, page) {
      if(id) {
        this.$store.dispatch("user/setSelectedID", id)
      }
      this.$router.push("/" + page)
    },
    resultUrl(e) {
      let mode = this.product
      switch(mode) {
        case "SLOTS":
          // return config.r2ResultUrl() + e.bet_id
          var result = config.r2ResultUrl() + e.bet_id
          if (e.bet_id.includes("LOSG_") || e.bet_id.includes("LCB_")) {
            result = config.r3ResultUrl() + e.bet_id
          }
          return result
        case "LIVECASINO":
          var account_id = this.$store.getters.accountID
          var login_id = this.$store.getters.loginID
          var profile_id = this.$store.getters.profileID
          var auth_token = this.$store.getters.authToken
          var result = config.r1ResultUrl() + "account_id=" + account_id + "&login_id=" + login_id + "&profile_id=" + profile_id + "&auth_token=" + auth_token +  "&result_id=" + e.result_id
          return encodeURI(result);
      }
    },
    getResultLive22Gaming(e) {
      if (this.detail.live22) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: "MYR"
      };
      this.detail.live22 = true;
      this.$http.post(config.live22Path, args).then(
        (res) => {
          this.detail.live22 = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultlive22", "top=10,height=400,width=640,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        (err) => {
          this.detail.live22 = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAR(e) {
      if (this.detail.arcadia) return;
      var id = e.replace("AR_", "");
      // console.log(id);
      var url = "";
      const args = {
        cert: config.arcadeCert,
        transId: id.toString()
      };
      this.detail.arcadia = true;
      this.$http.post(config.arcadePath, args).then(
        res => {
          this.detail.arcadia = false;
          if (res.data) {
            url = res.data.url;
            if (url) {
              window.open(url, "resultar", "top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.arcadia = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPGS(e) {
      if (this.detail.pgsoft) return;
      var id = e;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.detail.pgsoft = true;
      this.$http.post(config.pgsPath, args).then(
        res => {
          this.detail.pgsoft = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultpgs", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.pgsoft = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPPG(e) {
      if (this.detail.pragmatic) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.detail.pragmatic = true;
      this.$http.post(config.ppgPath, args).then(
        res => {
          this.detail.pragmatic = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultppg", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.pragmatic = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJKR(e) {
      if (this.detail.joker) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.detail.joker = true;
      this.$http.post(config.jkrPath, args).then(
        res => {
          this.detail.joker = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultppg", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.joker = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultSPP(e) {
      if (this.detail.spp) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        // userid: e.member_id
      };
      this.detail.spp = true;
      this.$http.post(config.sppPath, args).then(
        res => {
          this.detail.spp = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultspp", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.spp = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJILI(e) {
      if (this.detail.jili) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.detail.jili = true;
      this.$http.post(config.jiliPath, args).then(
        res => {
          this.detail.jili = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultjili", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.jili = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultLCPPG(e) {
      if (this.detail.lcppg) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.detail.lcppg = true;
      this.$http.post(config.lcppgPath, args).then(
        res => {
          this.detail.lcppg = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultlcppg", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.lcppg = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultUUSL(e) {
      if (this.detail.uusl) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.detail.uusl = true;
      this.$http.post(config.uuslPath, args).then(
        res => {
          this.detail.uusl = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultuusl", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.uusl = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultNEXT(e) {
      if (this.detail.next) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.detail.next = true;
      this.$http.post(config.nextPath, args).then(
        res => {
          this.detail.next = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.next = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultDbHash(e) {
      if (this.detail.dbhash) return;
      this.detail.dbhash = true;
      var account_id = this.$store.getters.accountID
      var login_id = this.$store.getters.loginID
      var profile_id = this.$store.getters.profileID
      var auth_token = this.$store.getters.authToken

      var url = config.dbhashPath + "?result_id=" + e.bet_id.toString() + "&auth_token=" + auth_token + "&profile_id=" + profile_id + "&login_id=" + login_id + "&account_id=" + account_id;
      this.detail.dbhash = false;
      window.open(url, "resultdbhash", "top=10,height=600,width=320,status=no,toolbar=no,menubar=no,location=no");
    },
    getResultWOW(e) {
      if (this.detail.wow) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.detail.wow = true;
      this.$http.post(config.wowgamingPath, args).then(
        res => {
          this.detail.wow = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.wow = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAI(e) {
      if (this.detail.ai) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.detail.ai = true;
      this.$http.post(config.aicasinoPath, args).then(
        res => {
          this.detail.ai = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.ai = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultWF(e) {
      if (this.detail.wf) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: "MYR"
      };
      this.detail.wf = true;
      this.$http.post(config.wfPath, args).then(
        res => {
          this.detail.wf = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultwf", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.wf = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultEPW(e) {
      if (this.detail.epw) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: "MYR"
      };
      this.detail.epw = true;
      this.$http.post(config.epwPath, args).then(
        res => {
          this.detail.epw = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultepw", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.epw = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAWC(e) {
      if (this.detail.awc) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.detail.awc = true;
      this.$http.post(config.awcPath, args).then(
        res => {
          this.detail.awc = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultawc", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.awc = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAIO(e) {
      if (this.detail.aio) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: "MYR"
      };
      this.detail.aio = true;
      this.$http.post(config.aioPath, args).then(
        res => {
          this.detail.aio = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              const newWindow = window.open("", "resultaio", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
              if (newWindow) {
                newWindow.document.head.innerHTML = `
                  <title>Game Result</title>
                  <link rel="stylesheet" href="/css/bootstrap.min.css">
                  <link rel="stylesheet" href="/css/info.css">
                  <style>
                    body {
                      margin: 20px;
                      background: #F4F7FC;
                    }
                  </style>
                `;
                newWindow.document.body.innerHTML = `<div class="result-container">${url}</div>`;
              }
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.aio = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultOnlive(e) {
      if (this.detail.onlive) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: "MYR"
      };
      this.detail.onlive = true;
      this.$http.post(config.onlivePath, args).then(
        res => {
          this.detail.onlive = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultonlive", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.onlive = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultMtlive(e) {
      if (this.detail.mtlive) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: "MYR"
      };
      this.detail.mtlive = true;
      this.$http.post(config.mtlivePath, args).then(
        res => {
          this.detail.mtlive = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultmtlive", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.detail.mtlive = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getPlatformLookUp: function() {
      let x = this.$store.getters.getPlatformLookUp
      let z = [
        // { value: "", text: this.$t("ui.all").toUpperCase() },
        { value: "SPORTSBOOK", text: this.$t("ui.sportsbook").toUpperCase() }
      ]
      x.forEach(y => {
        if(y.platform_code != 'KENO') {
          z.push({ value: y.platform_code, text: this.$t("ui." + y.platform_code.toLowerCase()).toUpperCase() })
        }
      })
      z.push({ value: "TOURNAMENT", text: this.$t("ui.tournament").toUpperCase() })
      // z.push({ value: "TOURNAMENT", text: this.$t("ui.tournament").toUpperCase() }, { value: "ADJUSTMENT", text: this.$t("ui.adjustment").toUpperCase() })
      return z
    },
    show: function(level) {
      return this.downlineLevel >= level ? "" : "d-none";
    },
    isShow: function(level) {
      return this.downlineLevel >= level ? true : false;
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.submit();
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false;
      } else {
        this.sortDesc = this.direction === "ASC";
      }

      this.sortBy = ctx.sortBy;
      this.submit();
      this.refreshTable("tblList");
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table);
    },
    submit: function() {
      this.$v.$touch()
      this.gameResultList = []
      if (!this.$v.$invalid) {
        let product = this.product;
        switch (product) {
          case "SPORTSBOOK":
            this.getSportsbookResult();
            break;
          case "LIVECASINO":
            this.getLivecasinoResult();
            break;
          case "SLOTS":
            this.getSlotgamesResult();
            break;
          case "LOTTERY":
            this.getLotteryResult();
            break;
          case "COCKFIGHT":
            this.getEsportsResult();
            break;
          case "TOURNAMENT":
            this.getTournamentResult();
            break;
          case "ADJUSTMENT":
            this.getAdjustmentResult();
            break;
          default:
            // this.getSportsbookResult();
            break;
        }
      }
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getParlayName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.leagueParlay.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.matchParlay.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getSportsbookResult: function() {
      let url = config.getGameResultSportsbookDetailUrl();
      let member_id = this.member_id;
      let sport_type = this.sport_type;
      let league_id = this.league_id;
      let match_id = this.match_id;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          sport_type,
          league_id,
          match_id,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true
              this.gameResultList = response.data
              this.match = response.names.match
              this.league = response.names.league
              this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getLivecasinoResult: function() {
      let url = config.getGameResultLivecasinoDetailUrl();
      let member_id = this.member_id;
      let game_name = this.game_name;
      let game_provider = this.game_provider;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          game_name,
          game_provider,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true;
              this.gameResultList = response.data;
              this.totalRows =
                response.data.length > 0
                  ? this.gameResultList[0]["totalrows"]
                  : 0;

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getSlotgamesResult: function() {
      let url = config.getGameResultSlotsDetailUrl();
      let member_id = this.member_id;
      let game_name = this.game_name;
      let game_provider = this.game_provider;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          game_name,
          game_provider,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true;
              this.gameResultList = response.data;
              this.totalRows =
                response.data.length > 0
                  ? this.gameResultList[0]["totalrows"]
                  : 0;

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getLotteryResult: function() {
      let url = config.getGameResultLotteryDetailUrl();
      let member_id = this.member_id;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true;
              this.gameResultList = response.data;
              this.totalRows =
                response.data.length > 0
                  ? this.gameResultList[0]["totalrows"]
                  : 0;

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getParlayDetail: function(item) {
      this.isMMO = false
      this.parlayList = [];
      if (item._showDetails) {
        this.gameResultList.forEach(value => {
          this.$set(value, "_showDetails", false);
        });
        this.$set(item, "_showDetails", true);
      }
      let bet_id = item.result_id;
      this.$store
        .dispatch("user/getParlayDetail", { bet_id })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getParlayDetailMMO: function(item) {
      this.isMMO = true
      this.parlayList = [];
      if (item._showDetails) {
        this.gameResultList.forEach(value => {
          this.$set(value, "_showDetails", false);
        });
        this.$set(item, "_showDetails", true);
      }
      let bet_id = item.result_id;
      this.$store
        .dispatch("user/getParlayDetailMMO", { bet_id })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getEsportsResult: function() {
      let url = config.getGameResultEsportsDetailUrl();
      let member_id = this.member_id;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true;
              this.gameResultList = response.data;
              this.totalRows =
                response.data.length > 0
                  ? this.gameResultList[0]["totalrows"]
                  : 0;

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getEsports2Combo: function(item) {
      this.esports2Combo = [];
      if (item._showDetails) {
        this.gameResultList.forEach(value => {
          this.$set(value, "_showDetails", false);
        });
        this.$set(item, "_showDetails", true);
      }
      let bet_id = item.bet_id;
      this.$store
        .dispatch("user/getEsportsDetailCombo", { bet_id })
        .then(response => {
          // console.log("Response: ", response);
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.esports2Combo = response.data;
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          // console.log("Response: ", response);
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getTournamentResult: function() {
      let url = config.getGameResultTournamentDetailUrl();
      let member_id = this.member_id;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true;
              this.gameResultList = response.data;
              this.totalRows =
                response.data.length > 0
                  ? this.gameResultList[0]["totalrows"]
                  : 0;

              response.data.forEach(value => {
                this.subTotalJackpot =
                  parseFloat(this.subTotalJackpot) +
                  parseFloat(value["jackpot_payout"]);

                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalJackpot =
                  response.grandTotal[0]["jackpot_payout"];

                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getAdjustmentResult: function() {
      let url = config.getGameResultAdjustmentDetailUrl();
      let member_id = this.member_id;
      let sport_type = this.sport_type;
      let league_id = this.league_id;
      let match_id = this.match_id;
      let search_by_working_date = this.working_date ? 1 : 0;
      let start_date = this.dateRange.startDate;
      let end_date = this.dateRange.endDate;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      let sort_key = this.sortBy;
      let sort_type = this.direction;
      this.loading = true;
      this.$store
        .dispatch("user/getGameResultDetail", {
          url,
          member_id,
          start_date,
          end_date,
          search_by_working_date,
          sport_type,
          league_id,
          match_id,
          page_number,
          page_size,
          sort_key,
          sort_type
        })
        .then(response => {
          this.clearTotal();
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.showTotal = true
              this.gameResultList = response.data
              this.match = response.names.match
              this.league = response.names.league
              this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalMemberWinlose =
                  parseFloat(this.subTotalMemberWinlose) +
                  parseFloat(value["member_winlose"]);
                this.subTotalMemberCommission =
                  parseFloat(this.subTotalMemberCommission) +
                  parseFloat(value["member_comm"]);
                this.subTotalMemberWinloseCommission =
                  parseFloat(this.subTotalMemberWinloseCommission) +
                  parseFloat(value["member_winlose_comm"]);

                this.subTotalAgentWinlose =
                  parseFloat(this.subTotalAgentWinlose) +
                  parseFloat(value["agent_winlose"]);
                this.subTotalAgentCommission =
                  parseFloat(this.subTotalAgentCommission) +
                  parseFloat(value["agent_comm"]);
                this.subTotalAgentWinloseCommission =
                  parseFloat(this.subTotalAgentWinloseCommission) +
                  parseFloat(value["agent_winlose_comm"]);

                this.subTotalMasterWinlose =
                  parseFloat(this.subTotalMasterWinlose) +
                  parseFloat(value["master_winlose"]);
                this.subTotalMasterCommission =
                  parseFloat(this.subTotalMasterCommission) +
                  parseFloat(value["master_comm"]);
                this.subTotalMasterWinloseCommission =
                  parseFloat(this.subTotalMasterWinloseCommission) +
                  parseFloat(value["master_winlose_comm"]);

                this.subTotalSeniorWinlose =
                  parseFloat(this.subTotalSeniorWinlose) +
                  parseFloat(value["senior_winlose"]);
                this.subTotalSeniorCommission =
                  parseFloat(this.subTotalSeniorCommission) +
                  parseFloat(value["senior_comm"]);
                this.subTotalSeniorWinloseCommission =
                  parseFloat(this.subTotalSeniorWinloseCommission) +
                  parseFloat(value["senior_winlose_comm"]);

                this.subTotalSuperSeniorWinlose =
                  parseFloat(this.subTotalSuperSeniorWinlose) +
                  parseFloat(value["s_senior_winlose"]);
                this.subTotalSuperSeniorCommission =
                  parseFloat(this.subTotalSuperSeniorCommission) +
                  parseFloat(value["s_senior_comm"]);
                this.subTotalSuperSeniorWinloseCommission =
                  parseFloat(this.subTotalSuperSeniorWinloseCommission) +
                  parseFloat(value["s_senior_winlose_comm"]);

                this.subTotalShareholderWinlose =
                  parseFloat(this.subTotalShareholderWinlose) +
                  parseFloat(value["shareholder_winlose"]);
                this.subTotalShareholderCommission =
                  parseFloat(this.subTotalShareholderCommission) +
                  parseFloat(value["shareholder_comm"]);
                this.subTotalShareholderWinloseCommission =
                  parseFloat(this.subTotalShareholderWinloseCommission) +
                  parseFloat(value["shareholder_winlose_comm"]);

                this.subTotalCompanyWinlose =
                  parseFloat(this.subTotalCompanyWinlose) +
                  parseFloat(value["company_winlose"]);
                this.subTotalCompanyCommission =
                  parseFloat(this.subTotalCompanyCommission) +
                  parseFloat(value["company_comm"]);
                this.subTotalCompanyWinloseCommission =
                  parseFloat(this.subTotalCompanyWinloseCommission) +
                  parseFloat(value["company_winlose_comm"]);
              });

              if (response.grandTotal.length > 0) {
                this.grandTotalMemberWinlose =
                  response.grandTotal[0]["member_winlose"];
                this.grandTotalMemberCommission =
                  response.grandTotal[0]["member_comm"];
                this.grandTotalMemberWinloseCommission =
                  response.grandTotal[0]["member_winlose_comm"];

                this.grandTotalAgentWinlose =
                  response.grandTotal[0]["agent_winlose"];
                this.grandTotalAgentCommission =
                  response.grandTotal[0]["agent_comm"];
                this.grandTotalAgentWinloseCommission =
                  response.grandTotal[0]["agent_winlose_comm"];

                this.grandTotalMasterWinlose =
                  response.grandTotal[0]["master_winlose"];
                this.grandTotalMasterCommission =
                  response.grandTotal[0]["master_comm"];
                this.grandTotalMasterWinloseCommission =
                  response.grandTotal[0]["master_winlose_comm"];

                this.grandTotalSeniorWinlose =
                  response.grandTotal[0]["senior_winlose"];
                this.grandTotalSeniorCommission =
                  response.grandTotal[0]["senior_comm"];
                this.grandTotalSeniorWinloseCommission =
                  response.grandTotal[0]["senior_winlose_comm"];

                this.grandTotalSuperSeniorWinlose =
                  response.grandTotal[0]["s_senior_winlose"];
                this.grandTotalSuperSeniorCommission =
                  response.grandTotal[0]["s_senior_comm"];
                this.grandTotalSuperSeniorWinloseCommission =
                  response.grandTotal[0]["s_senior_winlose_comm"];

                this.grandTotalShareholderWinlose =
                  response.grandTotal[0]["shareholder_winlose"];
                this.grandTotalShareholderCommission =
                  response.grandTotal[0]["shareholder_comm"];
                this.grandTotalShareholderWinloseCommission =
                  response.grandTotal[0]["shareholder_winlose_comm"];

                this.grandTotalCompanyWinlose =
                  response.grandTotal[0]["company_winlose"];
                this.grandTotalCompanyCommission =
                  response.grandTotal[0]["company_comm"];
                this.grandTotalCompanyWinloseCommission =
                  response.grandTotal[0]["company_winlose_comm"];
              }
            } else {
              this.clearTotal();
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.loading = false;
          this.clearTotal();
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    clearTotal() {
      this.$store.dispatch("user/setSelectedID", "")
      this.$store.dispatch("layout/setSportType", "");
      this.$store.getters.getLeagueID.id = "";
      this.$store.getters.getMatchID.id = "";

      this.showTotal = false
      this.gameResultList = []
      this.match = []
      this.league = []
      this.matchParlay = []
      this.leagueParlay = []
      this.totalRows = 0;
      this.subTotalGrossWinlose = 0;
      this.grandTotalGrossWinlose = 0;
      this.subTotalGrossCommission = 0;
      this.grandTotalGrossCommission = 0;
      // member
      this.subTotalMemberWinlose = 0;
      this.grandTotalMemberWinlose = 0;
      this.subTotalMemberCommission = 0;
      this.grandTotalMemberCommission = 0;
      this.subTotalMemberWinloseCommission = 0;
      this.grandTotalMemberWinloseCommission = 0;
      // agent
      this.subTotalAgentWinlose = 0;
      this.grandTotalAgentWinlose = 0;
      this.subTotalAgentCommission = 0;
      this.grandTotalAgentCommission = 0;
      this.subTotalAgentWinloseCommission = 0;
      this.grandTotalAgentWinloseCommission = 0;
      // master
      this.subTotalMasterWinlose = 0;
      this.grandTotalMasterWinlose = 0;
      this.subTotalMasterCommission = 0;
      this.grandTotalMasterCommission = 0;
      this.subTotalMasterWinloseCommission = 0;
      this.grandTotalMasterWinloseCommission = 0;
      // senior
      this.subTotalSeniorWinlose = 0;
      this.grandTotalSeniorWinlose = 0;
      this.subTotalSeniorCommission = 0;
      this.grandTotalSeniorCommission = 0;
      this.subTotalSeniorWinloseCommission = 0;
      this.grandTotalSeniorWinloseCommission = 0;
      // super senior
      this.subTotalSuperSeniorWinlose = 0;
      this.grandTotalSuperSeniorWinlose = 0;
      this.subTotalSuperSeniorCommission = 0;
      this.grandTotalSuperSeniorCommission = 0;
      this.subTotalSuperSeniorWinloseCommission = 0;
      this.grandTotalSuperSeniorWinloseCommission = 0;
      // shareholder
      this.subTotalShareholderWinlose = 0;
      this.grandTotalShareholderWinlose = 0;
      this.subTotalShareholderCommission = 0;
      this.grandTotalShareholderCommission = 0;
      this.subTotalShareholderWinloseCommission = 0;
      this.grandTotalShareholderWinloseCommission = 0;
      // company
      this.subTotalCompanyWinlose = 0;
      this.grandTotalCompanyWinlose = 0;
      this.subTotalCompanyCommission = 0;
      this.grandTotalCompanyCommission = 0;
      this.subTotalCompanyWinloseCommission = 0;
      this.grandTotalCompanyWinloseCommission = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-checkbox {
  width: 100% !important;
}

.gold-trophy {
  color: #FEE101;
}

.silver-trophy {
  color: #A7A7AD;
}

.bronze-trophy {
  color: #A77044;
}
</style>